import { lockButton } from 'src/lockButton'

function contractPeopleFunctions(contractPeopleDatatable) {
  $('#offcanvasRight').on('click', '.add_fields.add_contract_extra', function(event) {
    dirty = true

    var regexp, time
    time = new Date().getTime()
    regexp = new RegExp($(this).data('id'), 'g')
    $(this).closest('.tab-pane').find('.contract_extra_rows').prepend($(this).data('fields').replace(regexp, time))

    $('.tab-pane.active .contract_extra_row:first .customer-select').select2({
      ajax: {
        url: '/customers/customer_options',
        dataType: 'json'
      },
      dropdownParent: $('#offcanvasRight'),
      placeholder: I18n.t("selects.select_customer"),
      width: '100%'
    })

    $(this).blur()

    return event.preventDefault()
  })

  $('#offcanvasRight').on('click', '.remove-record', function(event) {
    if ($("#basic-information").find('form').attr('action').includes('contract_people')) {
      dirty = true

      $(this).prev('input[type=hidden]').val('1')
      $(this).closest('.row').nextAll('hr:first').hide()
      $(this).closest('.row').hide()

      return event.preventDefault()
    }
  })
}

export { contractPeopleFunctions }
